import { Provider } from "react-redux";
import { Location } from "@reach/router";
import store from "./_store";
import routes from "./_routes";
import { AppLayout } from "./pages/AppLayout";
import { ConfigProvider } from "antd";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#ee312a",
        },
      }}
    >
      <Provider store={store}>
        <Location>
          {({ location }) => (
            <AppLayout location={location}>{routes}</AppLayout>
          )}
        </Location>
      </Provider>
    </ConfigProvider>
  );
}

export default App;
